import { useDatabaseEntity } from './useDatabaseEntity';

export interface DecisionDetails {
  id: string;
  title: string;
  choices: string[];
  exclusive: boolean;
}

export function useDecision(decisionId: string | undefined) {
  const { entity, loading, error } = useDatabaseEntity<DecisionDetails>(decisionId, {
    entityType: 'Decision',
    build: (database, id) => {
      const obj = database.decisions()[id];
      if (!obj) return null;
      return {
        id,
        title: obj.title(),
        choices: obj.choices(),
        exclusive: obj.exclusive(),
      };
    },
  });
  return { decision: entity, loading, error };
}
